import { ToggleGroup } from '@interstate/components/ToggleGroup/ToggleGroup/ToggleGroup';
import type { ResidualFieldInputProps } from '@makemydeal/dr-dash-components';
import { useResidualField } from '@makemydeal/dr-dash-components';
import { NumericInput } from '@makemydeal/dr-shared-components/numeric-input';
import { DealTabs } from '@makemydeal/dr-shared-types';

import { useScenarioCellId } from '../../../hooks/useScenarioCellId';

import { CompositeValue } from '../../CompositeValue';
import { ScenarioManualEditMarker } from '../../ScenarioManualEditMarker';
import { ScenarioRow } from '../../ScenarioRow';

export const AdjResidualFieldRow = ({ inputProps }: { inputProps: ResidualFieldInputProps }) => {
    const { label, isReadOnlyForOpenGrid, overrideIndicatorProps, valueInputProps, unitToggleProps } = useResidualField({
        inputProps,
        fieldType: 'adjustedResidual',
        tab: DealTabs.SUMMARY
    });
    const inputId = useScenarioCellId('adjResidual');

    return (
        <ScenarioRow rowKey="adjResidual" label={label} inputId={inputId}>
            <CompositeValue control={!isReadOnlyForOpenGrid && <ToggleGroup {...unitToggleProps} toggleWidth="100%" />}>
                <ScenarioManualEditMarker {...overrideIndicatorProps}>
                    <NumericInput {...valueInputProps} inputPrefix={undefined} id={inputId} displayLabel={false} />
                </ScenarioManualEditMarker>
            </CompositeValue>
        </ScenarioRow>
    );
};
